import React, { PropTypes } from 'react';
import SearchBar from 'containers/SearchBar';

import './style.scss';

const MainNavigationSearchBar = props => {
  return (
    <div className="MainNavigationSearchBar">
      <SearchBar onEscape={props.onClose} />
      <a className="icon-search-close" onClick={props.onClose} />
    </div>
  );
};

MainNavigationSearchBar.propTypes = {
  onClose: PropTypes.func
};

export default MainNavigationSearchBar;




/** WEBPACK FOOTER **
 ** ./src/members/Main/MainNavigation/MainNavigationSearchBar/index.js
 **/